import React, { useEffect, useState } from 'react';

import ComboBox from '../../../../../components/ComboBox';
import CollapsableSection from '../../../../../components/CollapsibleSection';
import ButtonForm from '../../../../../components/ButtonForm';
import InputForm from '../../../../../components/InputForm';
import WidgetHeaderStyleFields from '../../../../../components/WidgetHeaderStyleFields';
import SelectableList from '../../../../../components/SelectableList';
import SelectionForm from '../../../../../components/SelectionForm';

import CheckIco from '../../../../../components/icons/CheckIco';
import TrashIco from '../../../../../components/icons/TrashIco';
import AddIco from '../../../../../components/icons/AddIco';

import Spinner from '../../../../../components/Spinner';
import { useAuth } from '../../../../../providers/AuthContext';
import { useAppContext } from '../../../../../providers/AppContext';
import { useNavigate } from 'react-router-dom';
import { useWidgets } from '../../../../../providers/WidgetContext';
import { useDashboards } from '../../../../../providers/DashboardContext';
import { createWidget, getWidgetById, updateWidget } from '../../../../../services/apiWidgests';
import { getAllParameters } from '../../../../../services/apiProcessParameteres';
import { translateDatePicker } from '../../../../utils';
import { useProcesses } from '../../../../../providers/ProcessesContext';

const ColumnField = ({ header , onDelete=() =>{}}) => {
  return (
    <div className='flex justify-between items-center w-full mr-3'>
      <div className='flex basis-1/3 items-center gap-1'>
        <span>{header.alias}</span>
      </div>
      <span className='basis-1/3 text-gray-400'>{header.key}</span>
      <button className="" onClick={() => onDelete(header)}>
        <TrashIco fill='red' />
      </button>
    </div>
  );
};

function TimeRateChartForm({onSubmit = () => {}, id}) {
  const {auth} = useAuth();
  const {addToast} = useAppContext();
  const navigate = useNavigate();
  
  const { addCard, assignSpace } = useWidgets();
  const { dashboard , selectedTab} = useDashboards();
  
  const [processList, setProcessList] = useState([]);
  const [selectedProcess, setSelectedProcess] = useState();
  const [parameters, setParameters] = useState();
  const {menuItems} = useProcesses();
  const [dataRange, setDataRange] = useState('Asignar por dashboard');
  const [title, setTitle] = useState('');
  const [validate, setValidate] = useState(false);
  const [conf, setConf] = useState();
  const [toCompare, setToCompare] = useState();
  const [valueToCompare, setValueToCompare] = useState();
  const [aggregation, setAggregation] = useState("add");
  const [timespan, setTimespan] = useState("hours");
  const [interval, setInterval] = useState(1);
  const [stage,setStage] = useState("form");

  const aggregationOptions = {
    "add": "Suma",
    "mean": "Promedio",
    "max": "Máximo",
    "min": "Mínimo",
    "count": "Conteo"
  }
  const timeOptions = {
    "minutes": "Minutos",
    "hours": "Horas",
    "days": "Días",
    "weaks": "Semanas",
    "months": "Meses"
  }

  const graphTypes = {
    "line": "Gráfico de linea",
    "VBars": "Gráfico de barras vertical",
    "HBars": "Gráfico de barras horizontal"
  }

//colores
  const colorOptions = {
    "pastel": "Paleta pastel",
    "blue": "Paleta azul",
    "red": "Paleta roja",
    "fixed": "Color fijo"
  }

  //backend flags
  const [loading, setLoading] = useState(true);
  const [fetchingParameters, setFetchingParameters] = useState(true);
  const [creatingWidget, setCreatingWidget] = useState(false);
  const [fetchingWidgetInfo, setFetchingWidgetInfo] = useState(true);
  const [newRule, setNewRule] = useState({});

  //obtener info existente del widget
  const refreshWidgetInfo = () => {
    async function fetchWigdet(){
      const widget = await getWidgetById(id, auth?.token);
      return widget; 
    }
    try {
      setFetchingWidgetInfo(true);
      fetchWigdet().then(response => {
        console.log(response.configuration)
        setConf(response.configuration)
        setSelectedProcess(response.configuration.process.id)
        setTimespan(response.configuration.timespan)
        setAggregation(response.configuration.aggregation)
        setInterval(response.configuration.interval)
        //setDataRange(response.configuration.dateRange.selectedRange === "byDashboard" ? "Asignar por dashboard": response.configuration.dateRange.selectedRange)
        setFetchingWidgetInfo(false);
        setTitle(response.title)
      }).catch(error => {
        if (error.response.status === 404){
          console.log("Widget no encontrado")
        }
        else if (error.response.status === 500){
          console.log("Error en el servidor, intente nuevamente")
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error,typeof(error));
      setFetchingWidgetInfo(false);
    }
  }
  
  const refreshParameters = () => {
    async function fetchParameters(){
      const parameters = await getAllParameters(selectedProcess, auth?.token);
      return parameters;
    }
    try {
      setFetchingParameters(true);
      fetchParameters().then(response => {
        console.log(console.log(response))
        setParameters(response.map(parameter => {
          return {
            key: parameter.key,
            alias: parameter.alias,
            type: parameter.datatype
          }
        }));
        setFetchingParameters(false);
      }).catch(error => {
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setFetchingParameters(false);
    }
  }

  const createWidgetDB = () => {
    async function fetchWidget(){
      const position= assignSpace();
      const widget = await createWidget({
        type: "processTimeRate",
        title: title,
        description: "",
        configuration: conf,
        dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 200,
        height: 200,
        selectedTab
      }, auth?.token);
      
      return widget;
    }
    try {
      setCreatingWidget(true);
      fetchWidget().then(response => {
        console.log(console.log(response));
        addCard (
          response._id,
          response.title,
          response.type,
          response.dashboardId,
          
        )
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget "+ title + " creado exitosamente.",1)
      }).catch(error => {
        console.log(error)
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setCreatingWidget(false);
    }
  }

  const editWidgetDB = () => {
    async function saveWidget(){

      const widget = await updateWidget(id,{
        type: "processTimeRate",
        title: title,
        description: "",
        configuration: conf,
        /* dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 200,
        height: 200, */
      }, auth?.token);
      
      return widget;
    }
    try {
      setCreatingWidget(true);
      saveWidget().then(response => {
        console.log(console.log(response));
        
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget "+ title + " editado exitosamente.",1);
      }).catch(error => {
        console.log(error)
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setCreatingWidget(false);
    }
  }

  const selectVariableToCompare = (selectedItems) => {
    if (parameters && selectedItems){
      const selectedToCompare = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.variableToCompare = selectedToCompare
      setConf({...tempConf})
    }
    
  }
  const deleteToCompare = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.variableToCompare = undefined
      setConf({...tempConf})
    } 
  }
  const selectValueToCompare = (selectedItems) => {
    if (parameters && selectedItems){
      const selectedValue = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.valueToCompare = selectedValue
      setConf({...tempConf})
    }
  }
  const selectFilterList = (selectedItems) => {
      if (parameters && selectedItems){
        const filterList = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
        let tempConf = {...conf}
        tempConf.filterList = filterList
        setConf({...tempConf})
      }
    }
  const selectGroupList = (selectedItems) => {
      if (parameters && selectedItems){
        const groupList = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
        let tempConf = {...conf}
        tempConf.groupList = groupList
        setConf({...tempConf})
      }
    }
  const deleteValue = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.valueToCompare = undefined
      setConf({...tempConf})
    } 
  }
  const deleteFilterList = (selectedItems) => {
      if (parameters && selectedItems){
        let tempConf = {...conf}
        tempConf.filterList = undefined
        setConf({...tempConf})
      } 
    }
  const deleteGroupList = (selectedItems) => {
      if (parameters && selectedItems){
        let tempConf = {...conf}
        tempConf.groupList = undefined
        setConf({...tempConf})
      } 
    }
  const handleProcessChange = (selectedProcess) => {
    let tempConf = {...conf}
    tempConf.variableToCompare = undefined;
    tempConf.valueToCompare = undefined;
    tempConf.process = {
      id: selectedProcess,
      name: processList[selectedProcess]
    }
    setConf({...tempConf})
  }
  const handleDataRangeChange = (selectedRange) => {
    setDataRange(translateDatePicker(selectedRange));
    let tempConf = {...conf}
    tempConf.dateRange = selectedRange
    setConf({...tempConf})
  }
  const handleDecimalsChange = (decimals) => {
    let tempConf = {...conf}
    tempConf.nDecimals = decimals
    setConf({...tempConf})
  }
  const handleChangeWidgetName = (name) => {
    setTitle(name)
  }
  const handleChangeAggregation = (aggregation) => {
    let tempConf = {...conf}
    tempConf.aggregation = aggregation
    setConf({...tempConf})
  }
  const handleChangeInterval = (interval) => {
    let tempConf = {...conf}
    tempConf.interval = Number(interval)
    setConf({...tempConf})
  }
  const handleChangeTimespan = (timespan) => {
    let tempConf = {...conf}
    tempConf.timespan = timespan
    setConf({...tempConf})
  }
  const handleGraphType = (graphType) => {
    let tempConf = {...conf}
    tempConf.graphType = graphType
    setConf({...tempConf})
  }
  const handleCreateWidget = () =>{
    createWidgetDB();
  }
  const handleEditWidget = () =>{
    editWidgetDB();
  }

  // --- FILTROS AVANZADOS ---
    const translateSpanishToCode = (spanish) => {
    switch(spanish) {
      case "Igual a": return "eq";
      case "Diferente de": return "ne";
      case "Mayor a": return "gt";
      case "Menor a": return "lt";
      case "Mayor o igual": return "gte";
      case "Menor o igual": return "lte";
      case "En lista": return "in";
      default: return "";
    }
  };

  const translateRuleCodeToSpanish = (code) => {
    switch(code) {
      case "eq": return "Igual a";
      case "ne": return "Diferente de";
      case "gt": return "Mayor a";
      case "lt": return "Menor a";
      case "gte": return "Mayor o igual";
      case "lte": return "Menor o igual";
      case "in": return "En lista";
      default: return "";
    }
  };

    const handleAddFilterRule = (ruleCode, ruleValue) => {
    setConf(prev => {
      const newRules = prev.filterList?.rules ? [...prev.filterList.rules] : [];
      newRules.push({ code: ruleCode, value: ruleValue });
      return { ...prev, filterList: { ...prev.filterList, rules: newRules } };
    });
  };

  const handleSetFilterField = (field) => {
    setConf(prev => ({
      ...prev,
      filterList: { ...prev.filterList, field }
    }));
  };

  const handleRemoveFilterRule = (index) => {
    setConf(prev => {
      const newRules = [...prev.filterList.rules];
      newRules.splice(index, 1);
      return { ...prev, filterList: { ...prev.filterList, rules: newRules } };
    });
  };

  const handleClearFilter = () => {
    setConf(prev => ({
      ...prev,
      filterList: undefined
    }));
  };

  const selectColorPalette = (selectedColor) => {
    if (selectedColor){
      let tempConf = {...conf}
      tempConf.colorPalette = selectedColor
      setConf({...tempConf})
    }
  }
  const selectFixedColor = (selectedColor) => {
    if (selectedColor){
      let tempConf = {...conf}
      tempConf.fixedColor = selectedColor
      setConf({...tempConf})
    }
  }
  const selectTextColor = (selectedColor) => {
    if (selectedColor){
      let tempConf = {...conf}
      tempConf.textColor = selectedColor
      setConf({...tempConf})
    }
  }
  
  useEffect( () => {
    if (selectedProcess){
      //limpiar headers actuales
      //cargar los parametros
      refreshParameters();
      //actualizar la configuracion
      handleProcessChange(selectedProcess);

    }
  }, [selectedProcess]);
  useEffect( () => {
    const bdConf = {
      process: undefined,
      valueToCompare: undefined,
      variableToCompare: undefined, 
      dateRange: {
        "activeTab": "customDates",
        "selectedRange": "byDashboard"
      },
      nDecimals: 2,
      dateFormat: "mm/dd/yy - hh:mm",
      aggregation: "add",
      timespan: "hours",
      interval: 1,
      graphType: "line"
    }

    setLoading(true);
    //cargar campos
    //cargar conf
    let processOptions = {}
    menuItems.slice(1).map(element => 
      processOptions[element.id] = element.label
    )
    console.log(processOptions);
    if(id) {
      refreshWidgetInfo()
    }
    else{
      setConf(bdConf);
      
    }
    setProcessList(processOptions);
    setLoading(false);
  }, []);
  useEffect( () => {
    if (stage === "form"){

    }
    if (stage === "columnSection"){

    }
  }, [])

  useEffect( () => {
    if (
      title === "" ||
      !conf?.process ||
      !conf.variableToCompare ||
      !conf.valueToCompare ||
      !conf?.dateRange ||
      !conf?.nDecimals ||
      !conf?.timespan ||
      !conf?.interval 
    ){
      setValidate(false);
    }
    else {
      setValidate(true);
    }
  }, [conf, title])

  useEffect( () => {
    if (id){
      refreshWidgetInfo()
    }
    setFetchingWidgetInfo(false)
    
  }, [id])

  return (
    <>
     {stage === "form" && (
      <>
        {conf && !fetchingWidgetInfo && (
            <div className='flex flex-col gap-2 h-[35rem] relative overflow-auto'>
              <div className=' flex flex-col flex-grow gap-2'>
                <CollapsableSection title={"Datos"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' open={true} border={false}>
                  <div className='flex flex-col gap-2'>
                    <div className='flex justify-between items-center w-[50%] mb-1.5'>
                      <SelectionForm
                        text="Proceso" 
                        options={Object.keys(processList)} 
                        mask={processList} 
                        value={selectedProcess}
                        onChange={event => setSelectedProcess(event)}
                        AppendClassName=' -mb-4'
                        error={!!selectedProcess && !fetchingParameters && parameters.length === 0 ? 'El proceso no tiene parametros creados' : ""}
                      /> 
                    
                    </div>
                    <CollapsableSection
                      title={"Valores a comparar (datos numéricos)"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        { conf.valueToCompare && (
                          <ColumnField header={conf.valueToCompare} onDelete={deleteValue}/>
                        )}
                        { !conf.valueToCompare && (
                          <div className=' mx-auto'>
                            <ButtonForm 
                              text={"Agregar campo"} 
                              Icon={() => {return (<AddIco fill='white'/>)}} 
                              enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                              action={ () => setStage("setValueToCompare")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>
                    <CollapsableSection 
                      title={"Variable de tiempo"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        { conf.variableToCompare && (
                          <ColumnField header={conf.variableToCompare} onDelete={deleteToCompare}/>
                        )}
                        { !conf.variableToCompare && (
                          <div className=' mx-auto'>
                            <ButtonForm 
                              text={"Agregar campo"} 
                              Icon={() => {return (<AddIco fill='white'/>)}} 
                              enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                              action={ () => setStage("setTimeValue")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>
                    <CollapsableSection
                      title={"Agrupar por"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        { conf.groupList && (
                          <ColumnField header={conf.groupList} onDelete={deleteGroupList}/>
                        )}
                        { !conf.groupList && (
                          <div className=' mx-auto'>
                            <ButtonForm 
                              text={"Agregar campo"} 
                              Icon={() => {return (<AddIco fill='white'/>)}} 
                              enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                              action={ () => setStage("setGroupList")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>
                      <CollapsableSection
                        title={"Filtrar por"}
                        titleBgColor='bg-aliceblue'
                        titleTextColor='text-gray'
                        open={true}
                      >
                        <div className='w-full flex flex-col px-4'>
                          { !!conf.filterList && (
                            <ColumnField header={conf.filterList} onDelete={deleteFilterList}/>
                          )}
                          { conf.filterList !== [] && (
                            <div className=' mx-auto'>
                              <ButtonForm 
                                text={"Agregar campo"} 
                                Icon={() => {return (<AddIco fill='white'/>)}} 
                                enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                                action={ () => setStage("setFilterList")}
                              />
                            </div>
                          )}
                        </div>
                      </CollapsableSection>
                    <div className='-mb-4 pt-2'>
                        <SelectionForm
                          text="Método de agregación" 
                          options={Object.keys(aggregationOptions)} 
                          mask={aggregationOptions}
                          value={aggregation}
                          onChange={event => handleChangeAggregation(event)}
                          AppendClassName=' -mb-4'
                        /> 
                    </div>
                    <div className='-mb-4 pt-4'>
                        <div className="flex gap-1 items-center">
                          <InputForm
                            text={"Intervalo"}
                            type="number"  
                            value={interval}
                            onChange={(event) => handleChangeInterval(event.target.value)}
                            AppendClassName=' -mb-4'
                          />
                          <SelectionForm
                            text="Tiempo"
                            value={timespan} 
                            options={Object.keys(timeOptions)} 
                            mask={timeOptions}
                            onChange={(event) => handleChangeTimespan(event)}
                            AppendClassName=' -mb-4'
                          /> 
                         
                        </div>
                    </div>
                    <div className='-mb-5 pt-4'>
                      <InputForm 
                        type={"datarange"} 
                        text={"Rango de tiempo"} 
                        value={dataRange} 
                        AppendClassName='text-left' 
                        onChange={(event) => handleDataRangeChange(event)}
                        dateRangeOptions={conf.dateRange}
                        addedRanges={ {"byDashboard": () => {}}} 
                      />
                    </div>
                    
                  </div>
                </CollapsableSection>
                <CollapsableSection title={"Apariencia"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' border={false} open={true}>
                  <div className='-mb-4 '>
                    <InputForm text={"Nombre"} value={title} onChange={(event) => setTitle(event.target.value)}/>
                  </div>
                  <div className='-mb-4 pt-2'>
                    <InputForm type={"number"} text={"Decimales"} value={conf.nDecimals} onChange={(event) => handleDecimalsChange(event.target.value)}/>
                  </div>
                  <div className='w-full -mb-4 pt-2'>
                    <SelectionForm
                      text="Tipo de grafica"
                      options={Object.keys(graphTypes)}
                      mask={graphTypes}
                      value={conf.graphType || "line"}
                      onChange={event => handleGraphType(event)}
                      AppendClassName=' '
                    />
                  </div>
                  <div className='-mb-4 pt-2'>
                    <InputForm type={"button"} text={"Estilo"} value={"Modificar estilo"} AppendClassName='text-left' onClick={() => {setStage("setAparience")}}/>
                  </div>
                </CollapsableSection>
              </div>

            {/* Span fijo al final del contenedor */}
            <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
              <div className='flex w-full justify-end'>
                <button className='' onClick={() => id ? handleEditWidget() : handleCreateWidget()}  disabled={!validate}>
                  <CheckIco width='50px' height='50px' fill={validate ? 'bluesens': 'gray'}/>
                </button>
              </div>
            </div>
          </div>
        )}
        {(!conf || fetchingWidgetInfo) && (
          <Spinner />
        )}
      </>
      
      
     )}
     {stage === "setTimeValue" && (
      <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
        <div className=' flex flex-col flex-grow gap-2'>
          <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
          <SelectableList 
            items={parameters.filter(element => element.type === "date").map(element => element.alias ? element.alias : element.key)} 
            multiSelect={false} 
            setItems={selectVariableToCompare}/>
        </div>
        
        {/* Span fijo al final del contenedor */}
        <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
          <div className='flex w-full justify-end'>
            < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
     )}
     {stage === "setValueToCompare" && (
      <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
        <div className=' flex flex-col flex-grow gap-2'>
          <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
          <SelectableList 
            items={parameters.filter(element => (element.type === "numeric" || element.type === "time")).map(element => element.alias ? element.alias : element.key)} 
            multiSelect={false} 
            setItems={selectValueToCompare}/>
        </div>
        
        {/* Span fijo al final del contenedor */}
        <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
          <div className='flex w-full justify-end'>
            < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
     )}
     {
     stage === "setGroupList" && (
        <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
          <div className=' flex flex-col flex-grow gap-2'>
            <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
            <SelectableList 
              items={parameters.filter(element => !element.type  ).map(element => element.alias ? element.alias : element.key)} 
              multiSelect={false} 
              setItems={selectGroupList}
            />
          </div>
          
          {/* Span fijo al final del contenedor */}
          <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
            <div className='flex w-full justify-end'>
              < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
            </div>
          </div>
        </div>
      )}

      {stage === "setFilterList" && (
          <div className='flex flex-col  h-[25rem] relative overflow-auto'>
            <div className='flex flex-col flex-grow gap-2'>
              <span className='font-semibold text-lg'>Selecciona un campo para filtrar</span>

              {/* Selección del campo */}
              <SelectionForm
                text="Campo"
                options={parameters.map(p => p.key)}
                value={conf.filterList?.field || ""}
                onChange={selectedField => {
                  handleSetFilterField(selectedField);
                }}
              />

              {/* Agregar nueva regla */}
                <div className='flex w-full  items-center gap-2 mt-2'>
                  <div className='w-[40%]'>
                    <SelectionForm
                      text="Regla"
                      options={["Igual a", "Diferente de", "Mayor a", "Menor a", "Mayor o igual", "Menor o igual", "En lista"]}
                      value={""}
                      onChange={selectedRule => setNewRule({ ...newRule, code: translateSpanishToCode(selectedRule) })}
                    />
                  </div>
                  <div className='w-[20%]'>
                    <InputForm
                      type="text"
                      placeholder="Valor"
                      value={newRule.value || ""}
                      onChange={e => setNewRule({ ...newRule, value: e.target.value })}
                    
                    />
                  </div>
                  <div className='w-[20%] flex items-center justify-center'>
                    <button
                      className='bg-bluesens text-white px-2 py-1 rounded'
                      onClick={() => {
                        handleAddFilterRule(newRule.code, newRule.value);
                        setNewRule({}); // limpiar input
                      }}
                      disabled={!newRule.code || !newRule.value}
                    >
                      Agregar regla
                    </button>
                  </div>
                  
                </div>

              {/* Reglas */}
              <div className='flex flex-col gap-2 mt-2'>
                {conf.filterList?.rules?.map((rule, index) => (
                  <div key={index} className='flex items-center gap-2'>
                    <span className='font-medium'>{index + 1}.</span>
                    <span>{translateRuleCodeToSpanish(rule.code)}</span>
                    <span>=</span>
                    <span>{rule.value}</span>
                    <button
                      className='text-red-500 ml-2'
                      onClick={() => handleRemoveFilterRule(index)}
                    >
                      Eliminar
                    </button>
                  </div>
                ))}

                
              </div>
            </div>

            {/* Span fijo al final */}
            <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
              <div className='flex w-full justify-end'>
                <ButtonForm text={"Guardar"} enabled={!!conf.filterList?.field} action={() => setStage('form')} />
              </div>
            </div>
          </div>
        )}

      {/* Apariencia */} 
        {stage === "setAparience" && (
          <div className="flex flex-col gap-2 h-[25rem] relative overflow-auto">
            <div className="flex flex-col flex-grow gap-2">
              <span className="font-semibold text-lg">Modificar estilo</span>
              <div className="pt-2">
                <WidgetHeaderStyleFields
                  headerColor={conf?.headerColor}
                  headerTextColor={conf?.headerTextColor}
                  onChange={(field, val) => setConf(prev => ({ ...prev, [field]: val }))}
                />
              </div>
  
              {/* Selección de paleta de colores */}
              <span className='text-sm font-medium text-gray-500 mt-1'>Gráfico</span>
              <SelectionForm
                id="colorPalette"
                text="Paleta de colores"
                options={Object.keys(colorOptions)}
                mask={colorOptions}
                value={conf?.colorPalette || "pastel"}
                onChange={(event) => selectColorPalette(event)}
              compact
              />
  
              {/* Mostrar el color fijo solo si se selecciona esa opción */}
              {conf?.colorPalette === "fixed" && (
                <InputForm
                  id="fixedColor"
                  type="color"
                  text="Seleccionar color fijo"
                  value={conf?.fixedColor || "#4287f5"}
                  onChange={(event) => selectFixedColor(event)}
                compact
                />
              )}
              <InputForm
                id="textColor"
                type="color"
                text="Seleccionar color del texto"
                value={conf?.textColor || "#000000"}
                onChange={(event) => selectTextColor(event)}
              compact
              />
            </div>
  
            {/* Botón fijo al final */}
            <div className="flex-none sticky bottom-0 bg-white p-2 shadow-lg">
              <div className="flex w-full justify-end">
                <ButtonForm
                  text={"Guardar"}
                  enabled={true}
                  action={() => setStage("form")}
                />
              </div>
            </div>
          </div>
        )}
    </>
   
    
  );
}

export default TimeRateChartForm;
